import { createContext } from 'react';

export interface AppContextInterface {
    latitude: number|null,
    longitude: number|null,
    pinValue: number,
    recentValue:number,
    singleClient: boolean
}

export const AppContext = createContext<AppContextInterface|null>(null);

